document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-our-work-images]')) {

        const fraction = document.getElementById("fraction");
        const slides = document.querySelectorAll(".s-our-works_new .swiper-slide");
        let slideCount = 0;
        if (fraction && slides !== undefined) {
            slideCount = slides.length;
            fraction.textContent = `1 / ${slideCount}`;
        }
        
        const ourWorkSlider = new Swiper('[data-our-work-images]', {
            slidesOffsetBefore: 0,
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            freeMode: {
                enabled: false
            },
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            navigation: {
                nextEl: '.c-our-work__button-next',
                prevEl: '.c-our-work__button-prev',
            },
            pagination: {
                el: '.c-our-work__pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                320: {
                    spaceBetween: 20
                },
                992: {
                    spaceBetween: 30
                }
            },
            on: {
                slideChange: () => {
                    
                }
            }
        });

        ourWorkSlider.on('slideChange', function () {
            if (fraction && slides !== undefined) {
                fraction.textContent = `${ourWorkSlider.realIndex + 1} / ${slideCount}`;
            }
        });
        document.querySelector('[data-our-work-images]').addEventListener('mouseover', function () {
            ourWorkSlider.autoplay.stop();
        })
        document.querySelector('[data-our-work-images]').addEventListener('mouseout', function () {
            ourWorkSlider.autoplay.start();
        })
    }
})
